import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { VehicleBrandDto } from '../../models/vehicle-brand.dto';

@Injectable({
  providedIn: 'root'
})
export class VehicleBrandService {

 private readonly path = '/vehicleBrand';
   
     constructor(private http: HttpClient) {}
   
     getByBusinessUnit(businessUnit: string): Observable<VehicleBrandDto[]> {
       return this.http.get<VehicleBrandDto[]>(`${environment.apiBaseUrl}${this.path}/${businessUnit}/businessUnit`);
     }
}
